export default "/images/8c4f4df8e20f08f7a1d2127ab8eba81f.avif";